import { selectionEntities } from "../native/blocks";
import type { NativeSession } from "../native/session";
import type { NativePointer } from "../native/pointer";
import { NativeShapeInspector } from "./native-shape-inspector";
import { NativeAppearanceInspector } from "./native-appearance-inspector";
import { NativeDimensionsInspector } from "./native-dimensions-inspector";
import { alignSelection } from "../native/selection-commands";

/** Inspector UI shares the same scene operations as pointer/keyboard commands. */
export class NativeInspector {
  private panels: { render(): void }[];
  constructor(
    private session: NativeSession,
    private pointer: NativePointer,
    private changed: () => void,
    private message: (text: string, error?: boolean) => void,
  ) {
    this.panels = ["native-", "native-compact-"].flatMap((prefix) => [
      ...(prefix === "native-"
        ? [
            new NativeDimensionsInspector(
              session,
              pointer,
              changed,
              message,
              prefix,
            ),
          ]
        : []),
      new NativeShapeInspector(session, pointer, changed, message, prefix),
      new NativeAppearanceInspector(session, pointer, changed, message, prefix),
    ]);
    for (const button of document.querySelectorAll<HTMLButtonElement>(
      "[data-native-align]",
    ))
      button.onclick = () => {
        if (pointer.active) return;
        try {
          session.replaceMany(
            alignSelection(session.selectedNodes, button.dataset.nativeAlign!),
          );
          session.finish();
          changed();
        } catch (error) {
          message((error as Error).message, true);
        }
      };
  }
  render() {
    this.panels.forEach((panel) => panel.render());
    const selected = this.session.selectedNodes;
    document.getElementById("native-selection-count")!.textContent =
      selected.length > 1
        ? `Выбрано объектов: ${selected.length}`
        : selected.length
          ? "Выбран 1 объект"
          : "Объект не выбран";
    document.getElementById("native-selection-title")!.textContent =
      selected.length > 1
        ? "Несколько объектов"
        : !selected.length
          ? "Свойства"
          : selected[0]!.kind === "image"
            ? "Изображение"
            : "Фигура";
    for (const name of ["dimensions", "appearance", "shape", "align"]) {
      const section = document.querySelector<HTMLElement>(
        `[data-property-section="${name}"]`,
      )!;
      section.hidden =
        name === "dimensions"
          ? selectionEntities(selected).length !== 1
          : name === "align"
            ? selectionEntities(selected).length < 2
            : name === "shape"
              ? !selected.some((n) => n.kind === "polygon")
              : !selected.length;
    }
    for (const button of document.querySelectorAll<HTMLButtonElement>(
      "[data-native-duplicate]",
    )) {
      button.hidden = !selected.length;
      button.disabled = this.pointer.active || !selected.length;
    }
    for (const button of document.querySelectorAll<HTMLButtonElement>(
      "[data-native-align]",
    ))
      button.disabled =
        this.pointer.active ||
        selectionEntities(selected).length <
          (button.dataset.nativeAlign!.startsWith("distribute") ? 3 : 2);
  }
}
